
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiConfig } from './config.api';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class AccountResourceApi {
  constructor(private httpClient: HttpClient) {
  }

  get() {
    return this.httpClient.get(ApiConfig.baseURL + 'api/account', {headers: ApiConfig.requestOptionsHeader});
  }

  checkActivation(activationKey) {
    let params = new HttpParams()
      .set('key', activationKey);

    return this.httpClient.get(ApiConfig.baseURL + 'api/account/activate', {params: params});
  }

  changePassword(body) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/account/changepassword', body, {headers: ApiConfig.requestOptionsHeader}).pipe(
      catchError((error: any) => (error.json().error || 'Server error')));
  }

  confirm(body) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/account/confirm', body, {headers: ApiConfig.requestOptionsHeader}).pipe(
      catchError((error: any) => (error.json().error || 'Server error')));
  }

  forgotPassword(body) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/account/forgotpassword', body, {headers: ApiConfig.requestOptionsHeader}).pipe(
      catchError((error: any) => ('Server error')));
  }

  searchByCertificateNumber(certificateNumber) {
    return this.httpClient.get(ApiConfig.baseURL + 'api/account/search?searchString=' + certificateNumber);
  }

  unlock(userId) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/account/unlock/' + userId, {headers: ApiConfig.requestOptionsHeader}).pipe(
      catchError((error: any) => (error.json().error || 'Server error')));
  }

  check(credentials) {
    let data = 'j_username=' + encodeURIComponent(credentials.username) +
      '&j_password=' + encodeURIComponent(credentials.password) +
      '&submit=Login';

    return this.httpClient.post(ApiConfig.baseURL + 'api/authentication', data, {headers: ApiConfig.requestOptionsHeaderForLogin});
  }
}
